import { FC, ReactElement } from 'react';

import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import styles from './Copied.module.css';

export const Copied: FC = (): ReactElement => {
  return (
    <div className={styles.Copied}>
      <L10nText tk="COPIED" />
    </div>
  );
};
